import { useQueryClient } from "@tanstack/react-query";

import { queries as adminQueries } from "~/services/admin/factories";
import { useRegisterAndBookMutation } from "~/services/scheduling/actions";
import { queries as schedulingQueries } from "~/services/scheduling/factories";
import type { AdminScheduleVisitResponse } from "~/services/scheduling/types";

export const useStaffBookVisit = (options?: {
  onMutate?: () => void;
  onSuccess?: (data: AdminScheduleVisitResponse) => void;
  onError?: (error: unknown) => void;
  onSettled?: () => void;
}) => {
  const queryClient = useQueryClient();

  return useRegisterAndBookMutation({
    ...options,
    onSuccess: (data) => {
      void queryClient.invalidateQueries({
        queryKey: ["getUser", data.user.id],
      });
      void queryClient.invalidateQueries({ queryKey: ["getUsers"] });
      queryClient.removeQueries({ queryKey: schedulingQueries._def });
      queryClient.removeQueries({
        queryKey: adminQueries.appointments(data.user.id).queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: adminQueries.bookingProviders._def,
      });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      void queryClient.invalidateQueries({
        queryKey: schedulingQueries.appointmentSlotsByProvider._def,
      });
      options?.onError?.(error);
    },
  });
};
